import SEOHead from "@/components/base/SEOHead";
import HeroSection from "./components/HeroSection";
import ServiceCategories from "./components/ServiceCategories";
import LiveEvents from "./components/LiveEvents";
import RecommendedCourses from "./components/RecommendedCourses";
import NewsSection from "./components/NewsSection";
import MembershipSection from "./components/MembershipSection";
import TestimonialSection from "./components/TestimonialSection";
import FAQSection from "./components/FAQSection";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "云体育",
  url: "https://boannote.cn",
  description: "云体育是专注于体育运动的一站式在线服务平台，涵盖体育赛事直播、运动课程、健身计划、体育资讯等全场景服务。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://boannote.cn/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "云体育",
  url: "https://boannote.cn",
  description: "云体育是专注于体育运动的一站式在线服务平台。",
  address: {
    "@type": "PostalAddress",
    streetAddress: "奥林匹克商务区云体育大厦",
    addressLocality: "北京",
    addressRegion: "朝阳区",
    addressCountry: "CN",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+86-400-888-6688",
    contactType: "customer service",
    availableLanguage: ["Chinese"],
  },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "云体育平台支持哪些设备？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "云体育支持全平台使用，包括网页端、iOS App、Android App、智能电视和iPad。",
      },
    },
    {
      "@type": "Question",
      name: "如何取消会员订阅？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "您可以在个人中心-会员管理中找到取消订阅选项。取消后当前周期的会员权益将持续到周期结束。",
      },
    },
    {
      "@type": "Question",
      name: "课程是否有观看期限？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "会员期间所有课程均无观看次数限制。部分付费单节课程的观看期限为购买后180天。",
      },
    },
    {
      "@type": "Question",
      name: "健身计划是否适合零基础用户？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "当然适合！AI智能系统会根据您的体能水平和目标，为每位用户量身定制适合自己的训练计划。",
      },
    },
    {
      "@type": "Question",
      name: "赛事直播是否有回放功能？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "所有直播赛事均提供赛后回放功能。高级会员可以观看全部历史赛事的完整回放。",
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="云体育 · 在线体育运动平台 - 赛事直播、运动课程、健身计划"
        description="云体育是专注于体育运动的一站式在线服务平台，涵盖体育赛事直播、运动课程、健身计划、体育资讯等全场景服务。加入云体育，随时随地享受专业体育运动体验，让运动融入你的每一天。"
        keywords="云体育,云体育平台,云体育赛事直播,云体育在线课程,云体育健身计划,云体育会员,云体育运动社区"
        canonicalUrl="https://boannote.cn"
        ogImage="https://readdy.ai/api/search-image?query=Dynamic%20sports%20athletes%20silhouette%20against%20warm%20sunset%20sky%2C%20modern%20clean%20composition%2C%20sports%20energy%20vibe%2C%20minimalist%20design&width=1200&height=630&seq=yunsports-og-home&orientation=landscape"
        schema={{ ...homeSchema, ...orgSchema, ...faqSchema }}
      />

      <main>
        <article>
          <HeroSection />
          <ServiceCategories />
          <LiveEvents />
          <RecommendedCourses />
          <NewsSection />
          <MembershipSection />
          <TestimonialSection />
          <FAQSection />
        </article>
      </main>
    </>
  );
}